
import { defineComponent } from 'vue'
import LoginForm from '@/views/login/login-form.vue'
import Cookies from 'js-cookie'
import { COOKIE_CONFIG } from '@/utils/tool'

export default defineComponent({
  components: { LoginForm },
  setup () {
    const withTeam = Cookies.get('hwLoginWithTeam') || ''

    Cookies.remove('hwLoginWithTeam', COOKIE_CONFIG)

    return {
      withTeam
    }
  }
})
